export const getWebBaseUrl = () => {
  return process.env.WEB_BASE_URL || 'http://localhost:1234'
}

export const getCanonicalUrl = (path: string) => {
  return `${getWebBaseUrl()}${path}`
}
